<template>
    <div class="w-full gap-3 item-center -mt-3 mb-2">
        <form @submit.prevent>
        <CustomInput class="w-full z-10" v-model="search" type="text" :placeholder="placeholderText">
            <div class="flex gap-x-2">
                <CustomButton class="w-min" id="viewPublisherButton" small text="Search" icon="Search" type="action" @click="$emit('search',search)" />
                <slot></slot>
            </div>
        </CustomInput>
    </form>
    </div>
</template>
<script>

import CustomInput from "@/components/inputs/CustomInput.vue";
import CustomButton from "@/components/inputs/CustomButton.vue";
 
export default {
    name: "lucide-icon",
    props: {
        placeholderText:{
            type:String
        }

    },
    components:{
        CustomInput,
        CustomButton

    },

    data() {
        return {
            search:""

        }
    },
    created() {

    },
    methods: {

    },
    computed: {


    },
    watch: {
    }
}


</script>